import script from "./score.vue?vue&type=script&setup=true&lang=js"
export * from "./score.vue?vue&type=script&setup=true&lang=js"

import "./score.vue?vue&type=style&index=0&id=58460188&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58460188"]])

export default __exports__